import {
    Avatar,
    Box,
    Flex,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Skeleton,
    Text,
    useColorModeValue
} from "@chakra-ui/react";
import { useAuth } from "providers/auth.provider";
import React from "react";
import { RiLogoutBoxLine } from "react-icons/ri";

type Props = {
    showName?: boolean;
};

export const UserDescription = ({ showName }: Props) => {
    const { signOut, info } = useAuth();
    const textColor = useColorModeValue("gray.600", "gray.200");
    const avatarOpacity = useColorModeValue(0.6, 1);
    const avatarBg = useColorModeValue("main.500", "rgb(105 192 247 / 22%)");

    const logout = async (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();        
        await signOut();
    };

    if (!info) {
        return <Skeleton height="25px" w={170} />;
    }

    return (
        <Box ml="6" display={{ base: "none", lg: "flex" }}>
            <Menu strategy="fixed" isLazy>
                <MenuButton>
                    <Flex alignItems="center">
                        <Avatar
                            size={"sm"}
                            bg={avatarBg}
                            color="gray.50"
                            name={info?.name?.toUpperCase()}
                            mr={2}
                            opacity={avatarOpacity}
                        />
                        {showName && (
                            <Text
                                color={textColor}
                                textAlign="left"
                                fontSize="sm"
                                fontWeight="medium"
                                maxW="140px"
                                isTruncated
                            >
                                {info?.name?.split(" ").slice(0, 2).join(" ")}
                            </Text>
                        )}
                    </Flex>
                </MenuButton>
                <MenuList py="2">
                    <MenuItem
                        onClick={logout}
                        icon={<RiLogoutBoxLine fontSize="1.1rem" />}
                        fontSize="sm"
                        py="2"
                    >
                        Sair
                    </MenuItem>
                </MenuList>
            </Menu>
        </Box>
    );
};
